export const FUNCIONARIOS_COURSE_CODE = "FUNCIONARIOS";
const STAFF_VALIDATE_ROLES = [
    "GATE_GUARD",
    "SCHOOL_ADMIN",
    "RECTOR",
];
const STAFF_BOARD_ROLES = [
    "INSPECTOR",
    "INSPECTOR_GENERAL",
    "SCHOOL_ADMIN",
    "RECTOR",
    "DOCENTE",
];
const INSPECTOR_ROLES = ["INSPECTOR", "INSPECTOR_GENERAL"];
export const isFuncionariosCourse = (course) => {
    if (!course)
        return false;
    if (course.entity === "funcionarios")
        return true;
    const code = String(course.course_code || course.course_id || "").toUpperCase();
    return code === FUNCIONARIOS_COURSE_CODE;
};
export const resolveStaffCargo = (course) => {
    const cargo = (course?.cargo_code ?? "").trim().toUpperCase();
    if (!cargo)
        return null;
    return cargo;
};
export const canValidateWithdrawalArrival = (course) => {
    const cargo = resolveStaffCargo(course);
    return cargo ? STAFF_VALIDATE_ROLES.includes(cargo) : false;
};
export const canManageWithdrawalBoard = (course) => {
    const cargo = resolveStaffCargo(course);
    return cargo ? STAFF_BOARD_ROLES.includes(cargo) : false;
};
/** Listado del día (solo lectura): portería + roles de tablero. */
export const canViewWithdrawalDayList = (course) => {
    const cargo = resolveStaffCargo(course);
    if (!cargo)
        return false;
    return cargo === "GATE_GUARD" || STAFF_BOARD_ROLES.includes(cargo);
};
export const canMarkWithdrawalActions = (course) => {
    const cargo = resolveStaffCargo(course);
    if (!cargo)
        return false;
    return ["INSPECTOR", "INSPECTOR_GENERAL", "SCHOOL_ADMIN", "RECTOR"].includes(cargo);
};
const ACADEMIC_ASSIGNMENT_CARGOS = ["DOCENTE", "RECTOR", "SCHOOL_ADMIN"];
export const canManageElectivos = (course) => {
    const cargo = resolveStaffCargo(course);
    return isFuncionariosCourse(course) && cargo
        ? ACADEMIC_ASSIGNMENT_CARGOS.includes(cargo)
        : false;
};
/** Docente, rector o administración escolar. Portería, inspector y chofer no. */
export const isAcademicStaffCourse = (course) => canManageElectivos(course);
export const isGateGuardCourse = (course) => isFuncionariosCourse(course) && resolveStaffCargo(course) === "GATE_GUARD";
export const findGateGuardCourse = (courses) => (courses || []).find((c) => isGateGuardCourse(c)) ?? null;
export const isInspectorCourse = (course) => {
    const cargo = resolveStaffCargo(course);
    return isFuncionariosCourse(course) && cargo
        ? INSPECTOR_ROLES.includes(cargo)
        : false;
};
export const findInspectorCourse = (courses) => (courses || []).find((c) => isInspectorCourse(c)) ?? null;
export const isDriverCourse = (course) => isFuncionariosCourse(course) && resolveStaffCargo(course) === "DRIVER";
export const findDriverCourse = (courses) => (courses || []).find((c) => isDriverCourse(c)) ?? null;
/**
 * Guardia “puro”: tiene membership de portería y no tiene cursos de apoderado/tesorería.
 * Su home operativo es Validar llegada.
 */
export const shouldUseGateGuardHome = (courses) => {
    const list = courses || [];
    if (!findGateGuardCourse(list))
        return false;
    return list.every((c) => isFuncionariosCourse(c));
};
/**
 * Inspector “puro”: solo cursos FUNCIONARIOS e incluye cargo INSPECTOR
 * o INSPECTOR_GENERAL. Su home operativo es Validación de ingreso.
 */
export const shouldUseInspectorHome = (courses) => {
    const list = courses || [];
    if (!findInspectorCourse(list))
        return false;
    return list.every((c) => isFuncionariosCourse(c));
};
/**
 * Chofer “puro”: solo cursos FUNCIONARIOS e incluye cargo DRIVER.
 * Su home operativo es el dashboard de Transporte.
 */
export const shouldUseDriverHome = (courses) => {
    const list = courses || [];
    if (!findDriverCourse(list))
        return false;
    return list.every((c) => isFuncionariosCourse(c));
};
export const GATE_GUARD_HOME_ROUTE = "validar-retiro";
export const INSPECTOR_HOME_ROUTE = "validar-ingreso";
export const DRIVER_HOME_ROUTE = "transporte";
export const resolveAppHomeRouteName = (courses) => {
    if (shouldUseDriverHome(courses))
        return DRIVER_HOME_ROUTE;
    if (shouldUseGateGuardHome(courses))
        return GATE_GUARD_HOME_ROUTE;
    if (shouldUseInspectorHome(courses))
        return INSPECTOR_HOME_ROUTE;
    return "main-view";
};
